<template lang="pug">
div(
    :class="styles.root"
)
    TheText(
        :class="styles.title"
        name="caption"
        color="foreground400"
    ) Оплатите в течение {{ timeLeft }}
</template>

<script lang="ts">
import Vue, { useCssModule } from 'vue'

import { TheText } from '@/shared/ui/TheText'
import { useTimer } from '@/shared/lib/hooks/useTimer'
import { useAppStore } from '@/shared/model'

export default Vue.extend({
    name: 'Timer',
    setup() {
        const styles = useCssModule()
        const {
            state: { timestamp },
        } = useAppStore()

        const { timeLeft } = useTimer({
            timestamp,
        })

        return {
            styles,
            timeLeft,
        }
    },
    components: {
        TheText,
    },
})
</script>

<style module lang="scss" src="./Timer.module.scss" />
